import React from 'react';
import TextField from '@mui/material/TextField';
import { authDarkTextFieldSx } from './loginDarkTheme';

/** Dark auth TextField with a single clean focus border (no glow ring). */
export default function AuthDarkTextField({ sx, InputLabelProps, ...props }) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      InputLabelProps={{ shrink: true, ...InputLabelProps }}
      sx={{ ...authDarkTextFieldSx, ...sx }}
      {...props}
    />
  );
}
